import { getInitialUANCState, IUANCState } from './config';
import Logger from '../../services/Logger';
import { STATE_SERVICE } from '../../configs/constants';

export default class DebugUANC extends Logger {
    unresolvedServices: string[];
    private observers: { [key: string]: (<T>(param: T) => unknown)[] };
    private notify: (prop: [string, boolean | STATE_SERVICE]) => void;
    setState: (newState: Partial<IUANCState>) => void;
    shouldUpdate: <T extends keyof IUANCState>(prop: T, fn: <K>(param: K) => unknown) => void;

    constructor() {
        super();
        window.Inpl.Ad.state = Object.assign(getInitialUANCState(true), window.Inpl.Ad.state ?? {});
        this.unresolvedServices = ['init'];
        this.observers = {};

        this.notify = (prop) => {
            const [key, value] = prop;
            if (this.observers[key]) {
                this.observers[key].forEach((fn) => fn(value));
            }
        };

        this.setState = (newState) => {
            window.Inpl.Ad.state = Object.assign(window.Inpl.Ad.state ? window.Inpl.Ad.state : getInitialUANCState(true), newState);
            Object.entries(newState).forEach((prop) => this.notify(prop));
        };

        this.shouldUpdate = (prop, fn) => {
            if (typeof this.observers[prop] === 'undefined') {
                this.observers[prop] = [];
                this.observers[prop].push(fn);
            } else {
                this.observers[prop].push(fn);
            }
        };
    }
}
